var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 1.55556,
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19248_10280",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19248_10280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.58705 10.0773C5.51675 10.0773 5.44888 10.0636 5.38345 10.0363C5.31801 10.009 5.25314 9.96322 5.18882 9.8989L2.79716 7.50724C2.70293 7.41302 2.65731 7.29934 2.66029 7.16623C2.66329 7.03311 2.7119 6.91944 2.80613 6.82521C2.90035 6.73097 3.01253 6.68385 3.14267 6.68385C3.27279 6.68385 3.38496 6.73097 3.47919 6.82521L5.61622 8.96222L10.5387 4.03979C10.6329 3.94556 10.7417 3.89844 10.8651 3.89844C10.9885 3.89844 11.0973 3.94556 11.1915 4.03979C11.2858 4.13402 11.3329 4.24283 11.3329 4.36623C11.3329 4.48962 11.2858 4.59843 11.1915 4.69266L5.98528 9.8989C5.92097 9.96322 5.85609 10.009 5.79065 10.0363C5.72522 10.0636 5.65735 10.0773 5.58705 10.0773Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckbox);
export default __webpack_public_path__ + "static/media/ic-checkbox.20cbb3d6b9bdcd06d4c3899c9baa31c8.svg";
export { ForwardRef as ReactComponent };